import { z } from 'zod';

export const TypographySettingsSchema = z.object({
  fontFamily: z.string().optional(),
  fontSize: z.string().optional(),
  fontWeight: z.string().optional(),
});
export type TypographySettings = z.infer<typeof TypographySettingsSchema>;

export const TypographyTypeSchema = z.enum([
  'title',
  'headline',
  'subheadline',
  'normalText',
  'smallText',
  'table',
  'chart',
]);

export type TypographyType = z.infer<typeof TypographyTypeSchema>;
